// Configurações de segurança e validação

import { supabase } from '../supabaseClient'

// Sistema de logging configurável
// const isDevelopment = process.env.NODE_ENV === 'development'

// const logger = {
//   debug: (...args) => {
//     if (isDevelopment) {
//       console.log('[DEBUG]', ...args)
//     }
//   },
//   info: (...args) => {
//     if (isDevelopment) {
//       console.info('[INFO]', ...args)
//     }
//   },
//   warn: (...args) => {
//     console.warn('[WARN]', ...args)
//   },
//   error: (...args) => {
//     console.error('[ERROR]', ...args)
//   }
// }

export const SECURITY_CONFIG = {
  // Configurações de senha
  PASSWORD: {
    MIN_LENGTH: 6,
    REQUIRE_UPPERCASE: false,
    REQUIRE_LOWERCASE: false,
    REQUIRE_NUMBERS: false,
    REQUIRE_SPECIAL_CHARS: false
  },
  
  // Configurações de email
  EMAIL: {
    REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    MAX_LENGTH: 254
  },
  
  // Configurações de nome
  NAME: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 100
  },
  
  // Configurações de sessão
  SESSION: {
    TIMEOUT: 24 * 60 * 60 * 1000, // 24 horas em milissegundos
    AUTO_REFRESH: true
  }
}

// Definição dos roles e suas permissões
export const USER_ROLES = {
  ADMINISTRADOR: 'administrador',
  ADMINISTRATIVO: 'administrativo',
  INSTALADOR: 'instalador',
  ESPECIALISTA: 'especialista',
  GERENTE: 'gerente',
  GERENTE_COMERCIAL: 'gerente_comercial',
  HOMOLOGADOR: 'homologador',
  CAMPO: 'campo',
  VISTORIADOR: 'vistoriador',
  PAP: 'pap',
  SDR: 'sdr',
  AVULSO: 'avulso'
}

// Permissões para cada funcionalidade
export const PERMISSIONS = {
  // Gerenciamento de usuários
  USER_MANAGEMENT: {
    CREATE: [USER_ROLES.ADMINISTRADOR],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO],
    UPDATE: [USER_ROLES.ADMINISTRADOR],
    DELETE: [USER_ROLES.ADMINISTRADOR],
    CHANGE_STATUS: [USER_ROLES.ADMINISTRADOR]
  },
  
  // Gerenciamento de clientes
  CLIENT_MANAGEMENT: {
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.HOMOLOGADOR, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.HOMOLOGADOR, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.HOMOLOGADOR, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR], // Apenas administradores podem excluir
    EDIT: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.HOMOLOGADOR, USER_ROLES.GERENTE_COMERCIAL],
    REMOVE: [USER_ROLES.ADMINISTRADOR], // Apenas administradores podem remover
    CONCLUDE_WORK: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR]
  },
  
  // Lista de presença
  ATTENDANCE_LIST: {
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Dashboard e relatórios
  DASHBOARD: {
    ACCESS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.VISTORIADOR, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Gerenciamento de colaboradores
  COLLABORATOR_MANAGEMENT: {
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    CHANGE_STATUS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Gerenciamento de equipes
  TEAM_MANAGEMENT: {
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    CHANGE_STATUS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Gerenciamento de veículos
  VEHICLE_MANAGEMENT: {
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    CHANGE_STATUS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Gerenciamento de cargos
  CARGO_MANAGEMENT: {
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    CHANGE_STATUS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Gerenciamento de usuários instaladores para clientes
  INSTALLER_USER_MANAGEMENT: {
    ASSIGN: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR],
    CHANGE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO]
  },
  
  // Medição e relatórios
  MEDICAO: {
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR],
    EXPORT: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO],
    CALCULATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR]
  },
  
  // Lista de material
  LISTA_MATERIAL: {
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL],
    EXPORT: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Gerenciamento de empresas
  EMPRESA_MANAGEMENT: {
    CREATE: [USER_ROLES.ADMINISTRADOR],
    READ: [USER_ROLES.ADMINISTRADOR],
    UPDATE: [USER_ROLES.ADMINISTRADOR],
    DELETE: [USER_ROLES.ADMINISTRADOR]
  },
  
  // WhatsApp — CRM para especialistas/gerentes; configuração API para administradores
  WHATSAPP: {
    ACCESS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA],
    SEND_MESSAGE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA],
    ADMIN_CONFIG: [USER_ROLES.ADMINISTRADOR]
  },

  // Kit Solar - apenas administradores
  KIT_SOLAR: {
    ACCESS: [USER_ROLES.ADMINISTRADOR],
    VIEW_PRODUCTS: [USER_ROLES.ADMINISTRADOR],
    SEARCH_PRODUCTS: [USER_ROLES.ADMINISTRADOR]
  },
  
  // Monte seu Kit - apenas administradores
  MONTE_SEU_KIT: {
    ACCESS: [USER_ROLES.ADMINISTRADOR],
    ASSEMBLE_KIT: [USER_ROLES.ADMINISTRADOR],
    VIEW_CART: [USER_ROLES.ADMINISTRADOR]
  },
  
  // Calculadora Solar - administradores, especialistas, gerentes e gerentes comerciais
  CALCULADORA_SOLAR: {
    ACCESS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    CALCULATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    SAVE_PROPOSAL: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    GENERATE_PDF: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Consulta de Propostas - administradores, especialistas, gerentes e gerentes comerciais
  CONSULTA_PROPOSTAS: {
    ACCESS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    VIEW_ALL: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL], // Administradores, gerentes e gerentes comerciais veem todas as propostas
    VIEW_OWN: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL], // Todos veem suas próprias propostas
    FILTER: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    EXPORT: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Valores de Kit - administradores, gerentes e gerentes comerciais
  VALOR_KIT: {
    ACCESS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL]
  },
  
  // Ordens de Serviço - administradores, administrativos, gerentes e gerentes comerciais
  ORDEM_SERVICOS: {
    ACCESS: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    CREATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    READ: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    UPDATE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    DELETE: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL],
    CANCEL: [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL]
  }
}

// Funções de validação
export const validators = {
  // Validar email
  isValidEmail: (email) => {
    if (!email || typeof email !== 'string') return false
    return SECURITY_CONFIG.EMAIL.REGEX.test(email) && 
           email.length <= SECURITY_CONFIG.EMAIL.MAX_LENGTH
  },
  
  // Validar senha
  isValidPassword: (password) => {
    if (!password || typeof password !== 'string') return false
    if (password.length < SECURITY_CONFIG.PASSWORD.MIN_LENGTH) return false
    
    if (SECURITY_CONFIG.PASSWORD.REQUIRE_UPPERCASE && 
        !/[A-Z]/.test(password)) return false
    
    if (SECURITY_CONFIG.PASSWORD.REQUIRE_LOWERCASE && 
        !/[a-z]/.test(password)) return false
    
    if (SECURITY_CONFIG.PASSWORD.REQUIRE_NUMBERS && 
        !/\d/.test(password)) return false
    
    if (SECURITY_CONFIG.PASSWORD.REQUIRE_SPECIAL_CHARS && 
        !/[!@#$%^&*(),.?":{}|<>]/.test(password)) return false
    
    return true
  },
  
  // Validar nome
  isValidName: (name) => {
    if (!name || typeof name !== 'string') return false
    const trimmedName = name.trim()
    return trimmedName.length >= SECURITY_CONFIG.NAME.MIN_LENGTH && 
           trimmedName.length <= SECURITY_CONFIG.NAME.MAX_LENGTH
  },
  
  // Sanitizar entrada de texto
  sanitizeText: (text) => {
    if (!text || typeof text !== 'string') return ''
    return text.trim().replace(/[<>]/g, '') // Remover caracteres potencialmente perigosos
  }
}

// Funções de segurança
export const security = {
  // Verificar se o usuário tem permissão para uma ação
  canPerformAction: (user, action, targetUser = null) => {
    if (!user) return false
    
    switch (action) {
      case 'edit_user':
        return user.id === targetUser?.id || user.role === 'admin'
      case 'delete_user':
        return user.id !== targetUser?.id && (user.role === 'admin' || user.role === 'manager')
      case 'change_status':
        return user.id !== targetUser?.id || user.role === 'admin'
      default:
        return false
    }
  },
  
  // Verificar se a sessão ainda é válida
  isSessionValid: (lastActivity) => {
    if (!lastActivity) return false
    const now = Date.now()
    const timeDiff = now - lastActivity
    return timeDiff < SECURITY_CONFIG.SESSION.TIMEOUT
  },
  
  // Verificar permissão baseada no role do usuário
  hasPermission: (userRole, permission, action) => {
    if (!userRole || !permission || !action) {
      return false
    }
    
    const permissionConfig = PERMISSIONS[permission]
    if (!permissionConfig) {
      return false
    }
    
    const allowedRoles = permissionConfig[action]
    if (!allowedRoles) {
      return false
    }
    
    return allowedRoles.includes(userRole)
  },
  
  // Verificar se o usuário pode acessar um menu específico (versão síncrona que usa cache)
  // Administradores têm acesso a tudo
  // Administrativo, Instalador, Vistoriador e Avulso: só veem menus liberados em Permissões de Menus (sem fallback legado)
  // Qualquer usuário com permissões customizadas (ex.: Especialista): só vê o que está liberado em Permissões de Menus (sem fallback legado)
  canAccessMenu: (userRole, menuName, permissoesCache = {}, hasPermissoesCustomizadas = false) => {
    if (!userRole) return false
    
    // Administradores têm acesso a tudo
    if (userRole === USER_ROLES.ADMINISTRADOR) {
      return true
    }

    if (menuName === 'valor_kit' && permissoesCache.valor_kit_consulta === true) {
      return true
    }

    if (menuName === 'cadastro_inversores_modulos') {
      return userRole === USER_ROLES.ADMINISTRATIVO
    }
    
    // Administrativo, Instalador, Vistoriador e Avulso: verificar apenas os menus liberados em Permissões de Menus (sem fallback legado)
    // Avulso não tem nenhum menu por padrão; só vê o que for liberado na tela Permissão de Menus
    if (
      userRole === USER_ROLES.ADMINISTRATIVO ||
      userRole === USER_ROLES.INSTALADOR ||
      userRole === USER_ROLES.VISTORIADOR ||
      userRole === USER_ROLES.AVULSO
    ) {
      return permissoesCache[menuName] === true
    }
    
    // Permissões salvas em Permissões de Menus: true/false explícitos vencem; sem registro para o menu → fallback legado
    // (menus novos ou migração: até o admin salvar de novo, quem já tinha acesso por papel continua vendo).
    if (hasPermissoesCustomizadas) {
      const raw = permissoesCache[menuName]
      if (raw === true) return true
      if (raw === false) return false
      return security.canAccessMenuLegacy(userRole, menuName)
    }
    
    // Se não tem permissões customizadas, usar a lógica legada baseada em roles
    return security.canAccessMenuLegacy(userRole, menuName)
  },
  
  // Função legada para verificar acesso por role (usada como fallback)
  canAccessMenuLegacy: (userRole, menuName) => {
    if (!userRole) return false
    
    switch (menuName) {
      case 'usuarios':
        return [USER_ROLES.ADMINISTRADOR].includes(userRole) // Apenas administradores
      case 'clientes':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.HOMOLOGADOR, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'clientes_ii':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.HOMOLOGADOR].includes(userRole)
      case 'cadastrar_clientes':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'vendas':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.ESPECIALISTA].includes(userRole)
      case 'presenca':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'colaboradores':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'equipes':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'veiculos':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'cargos':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'medicao':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR].includes(userRole) // Gerente Comercial NÃO tem acesso
      case 'lista_material':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'pagamento_colaborador':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO].includes(userRole) // Gerente Comercial NÃO tem acesso
      case 'adiantamento':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'dashboard':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR, USER_ROLES.VISTORIADOR, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.SDR].includes(userRole)
      case 'kit_solar':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'monte_seu_kit':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'valor_kit':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'kits_personalizados':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'kit_fornecedores':
        return false // Somente administrador, ou usuário com o menu liberado em Permissões de Menus
      case 'calculadora_solar':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'consulta_propostas':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'propostas_cadastro':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA].includes(userRole)
      case 'ordem_servicos':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'servicos':
        return [USER_ROLES.ADMINISTRADOR].includes(userRole) // Demais roles só veem se liberado em Permissões Menus
      case 'vistorias':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.HOMOLOGADOR, USER_ROLES.CAMPO, USER_ROLES.VISTORIADOR, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'gestao_instalacao':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.CAMPO, USER_ROLES.INSTALADOR, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'engenharia_homologacao':
        return [
          USER_ROLES.ADMINISTRADOR,
          USER_ROLES.HOMOLOGADOR,
          USER_ROLES.GERENTE_COMERCIAL,
          USER_ROLES.ADMINISTRATIVO,
          USER_ROLES.GERENTE,
          USER_ROLES.ESPECIALISTA,
          USER_ROLES.CAMPO
        ].includes(userRole)
      case 'fluxo_cliente':
        return [
          USER_ROLES.ADMINISTRADOR,
          USER_ROLES.HOMOLOGADOR,
          USER_ROLES.GERENTE_COMERCIAL,
          USER_ROLES.ADMINISTRATIVO,
          USER_ROLES.GERENTE,
          USER_ROLES.ESPECIALISTA,
          USER_ROLES.CAMPO
        ].includes(userRole)
      case 'painel_processos':
        return [
          USER_ROLES.ADMINISTRADOR,
          USER_ROLES.HOMOLOGADOR,
          USER_ROLES.GERENTE_COMERCIAL,
          USER_ROLES.ADMINISTRATIVO,
          USER_ROLES.GERENTE,
          USER_ROLES.ESPECIALISTA,
          USER_ROLES.CAMPO,
          USER_ROLES.INSTALADOR,
          USER_ROLES.VISTORIADOR
        ].includes(userRole)
      case 'engenharia_inversores':
        return [
          USER_ROLES.ADMINISTRADOR,
          USER_ROLES.HOMOLOGADOR,
          USER_ROLES.GERENTE_COMERCIAL,
          USER_ROLES.ADMINISTRATIVO,
          USER_ROLES.GERENTE,
          USER_ROLES.ESPECIALISTA
        ].includes(userRole)
      case 'tipos_servico':
        return [USER_ROLES.ADMINISTRADOR].includes(userRole) // Gerente Comercial NÃO tem acesso
      case 'tipos_padrao':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'calendario':
        return [USER_ROLES.ADMINISTRADOR].includes(userRole) // Só admin por padrão; exceção via Permissão de menus (permissoes_menus)
      case 'leads':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.SDR].includes(userRole)
      case 'gestao_leads':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.SDR].includes(userRole)
      case 'cadastrar_leads':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.PAP, USER_ROLES.SDR].includes(userRole)
      case 'leads_sdr':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.SDR].includes(userRole)
      case 'leads_capacitacao':
        return false // Apenas administrador ou via permissão de menu
      case 'dashboard_v2':
        return [USER_ROLES.ADMINISTRADOR].includes(userRole) // Padrão: só admin; liberar via Permissões de Menu
      case 'monitoramento':
        return [
          USER_ROLES.ADMINISTRADOR,
          USER_ROLES.ADMINISTRATIVO,
          USER_ROLES.GERENTE,
          USER_ROLES.GERENTE_COMERCIAL,
          USER_ROLES.HOMOLOGADOR,
          USER_ROLES.ESPECIALISTA
        ].includes(userRole)
      case 'financeiro':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'cadastro_tipos_movimentacao':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'cadastro_inversores_modulos':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO].includes(userRole)
      case 'lancar_movimentacoes':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
      case 'orcamentos':
        return false // Apenas via permissão de menu ou administrador
      case 'whatsapp':
        return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.ESPECIALISTA].includes(userRole)
      default:
        return false
    }
  },
  
  // Carregar permissões de menus do banco de dados para um usuário
  loadPermissoesMenus: async (userId) => {
    try {
      const { data, error } = await supabase
        .from('permissoes_menus')
        .select('menu_name, permitido')
        .eq('usuario_id', userId)
      
      if (error) {
        console.error('Erro ao carregar permissões de menus:', error)
        return {}
      }
      
      // Converter array em objeto { menu_name: true | false } (normaliza boolean do Postgres/JSON)
      const permissoesObj = {}
      if (data && data.length > 0) {
        data.forEach(perm => {
          const v = perm.permitido
          if (v === true || v === 'true' || v === 't' || v === 1 || v === '1') {
            permissoesObj[perm.menu_name] = true
          } else if (v === false || v === 'false' || v === 'f' || v === 0 || v === '0') {
            permissoesObj[perm.menu_name] = false
          }
          // null / outros: não define a chave → canAccessMenu usa fallback legado para esse menu
        })
      }
      
      return permissoesObj
    } catch (error) {
      console.error('Erro ao carregar permissões de menus:', error)
      return {}
    }
  },
  
  // Obter o nome amigável do role
  getRoleDisplayName: (role) => {
    switch (role) {
      case USER_ROLES.ADMINISTRADOR:
        return 'Administrador'
      case USER_ROLES.ADMINISTRATIVO:
        return 'Administrativo'
      case USER_ROLES.INSTALADOR:
        return 'Instalador'
      case USER_ROLES.ESPECIALISTA:
        return 'Especialista'
      case USER_ROLES.GERENTE:
        return 'Gerente'
      case USER_ROLES.GERENTE_COMERCIAL:
        return 'Gerente Comercial'
      case USER_ROLES.HOMOLOGADOR:
        return 'Homologador'
      case USER_ROLES.CAMPO:
        return 'Campo'
      case USER_ROLES.VISTORIADOR:
        return 'Vistoriador'
      case USER_ROLES.PAP:
        return 'PAP'
      case USER_ROLES.SDR:
        return 'SDR'
      default:
        return 'Usuário'
    }
  },
  
  // Verificar se o usuário pode remover clientes
  canRemoveClient: (userRole) => {
    return userRole === USER_ROLES.ADMINISTRADOR
  },
  
  // Verificar se o usuário pode gerenciar usuários
  canManageUsers: (userRole) => {
    return userRole === USER_ROLES.ADMINISTRADOR
  },
  
  // Verificar se o usuário pode acessar medição
  canAccessMedicao: (userRole) => {
    return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO, USER_ROLES.INSTALADOR].includes(userRole)
  },
  
  // Verificar se o usuário pode exportar medição
  canExportMedicao: (userRole) => {
    return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ADMINISTRATIVO].includes(userRole)
  },
  
  // Verificar se o usuário pode acessar WhatsApp (testes API)
  canAccessWhatsApp: (userRole) => {
    return userRole === USER_ROLES.ADMINISTRADOR
  },

  // Verificar se o usuário pode acessar Kit Solar
  canAccessKitSolar: (userRole) => {
    return userRole === USER_ROLES.ADMINISTRADOR
  },
  
  // Verificar se o usuário pode acessar Monte seu Kit
  canAccessMonteSeuKit: (userRole) => {
    return userRole === USER_ROLES.ADMINISTRADOR
  },
  
  // Verificar se o usuário pode acessar Calculadora Solar
  canAccessCalculadoraSolar: (userRole) => {
    return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
  },
  
  // Verificar se o usuário pode acessar Consulta de Propostas
  canAccessConsultaPropostas: (userRole) => {
    return [USER_ROLES.ADMINISTRADOR, USER_ROLES.ESPECIALISTA, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
  },
  
  // Verificar se o usuário pode ver todas as propostas (administradores, gerentes e gerentes comerciais)
  canViewAllProposals: (userRole) => {
    return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
  },
  
  // Verificar se o usuário pode acessar Valores de Kit
  canAccessValorKit: (userRole) => {
    return [USER_ROLES.ADMINISTRADOR, USER_ROLES.GERENTE, USER_ROLES.GERENTE_COMERCIAL].includes(userRole)
  },

  podeEditarValorKit: (userRole, permissoesCache = {}) => {
    if (userRole === USER_ROLES.ADMINISTRADOR) return true
    return permissoesCache.valor_kit_consulta !== true
  },

  podeEditarKitFornecedores: (userRole) => {
    return userRole === USER_ROLES.ADMINISTRADOR
  },
  
  // Verificar se o usuário é gerente
  isGerente: (userRole) => {
    return userRole === USER_ROLES.GERENTE
  }
}
